<div class="vi-tabs-wrap">
  <mat-tab-group class="vi-tabs">
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="vi-tab-label">{{ 'common.outgoing' | t }}</span>
    </ng-template>
    <div class="tab-content">
      <fs-lpr-outgoing-table></fs-lpr-outgoing-table>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="vi-tab-label">{{ 'common.incoming' | t }}</span>
    </ng-template>
    <div class="tab-content">
      <fs-lpr-incoming-table></fs-lpr-incoming-table>
    </div>
  </mat-tab>
  </mat-tab-group>
  <div class="vi-tab-mask"></div>
  <div class="vi-actions">
    <button type="button" class="vi-btn vi-btn--outline">
      {{ 'vehicleIntelligence.lprSharing.exportPartnerList' | t }}
    </button>
    <button type="button" class="vi-btn vi-btn--primary">
      <mat-icon class="vi-btn__icon">public</mat-icon>
      {{ 'vehicleIntelligence.lprSharing.discoverPartners' | t }}
    </button>
  </div>
</div>

